module.exports = __webpack_public_path__ + "static/media/new_home_icon.624b4e79.png";